/**
 * 因为坐标和计算精度，会有很多其实重合但是他们的坐标不是完全一样，而是非常接近的值，这种都用近似值来做判定
 */
export function isCloseEqual(a: number, b: number) {
    const epsilon = 1e-3;
    return Math.abs(a - b) <= epsilon;
}

export function isGreater(a: number, b: number) {
    return !isCloseEqual(a, b) && a > b;
}
